import { IconSearch } from '@rossum/ui/icons/tabler';
import { IconButton, SvgIcon } from '@rossum/ui/material';

type SearchButtonProps = {
  onClick: () => void;
};

export const SearchButton = ({ onClick }: SearchButtonProps) => {
  return (
    <IconButton size="medium" color="secondary" onClick={onClick}>
      <SvgIcon fontSize="medium">
        <IconSearch />
      </SvgIcon>
    </IconButton>
  );
};
